<template>
  <v-dialog v-model="dialog"  max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary"  v-bind="attrs" v-on="on" :disabled="selected_users.length === 0">
        Asignar cupones
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5">
        Asignar cupones a usuarios
      </v-card-title>
      <v-card-text>
        <v-row
          class="align-center"
          v-for="user in selected_users"
          :key="user.id"
        >
          <v-col cols="4 h-100">
            {{ user.name || '' }} {{ user.last_name || '' }}
          </v-col>
          <v-col cols="8">
            <v-text-field
              class="pt-0 mt-0"
              label="Num Cupones"
              type="number"
              :hide-details="true"
              v-model="user.count_coupons"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialog = false">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalAssignUser",
  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      selected_users: [],
    };
  },
  watch: {
    users: {
      handler(val) {
        this.selected_users = val.map((item) => ({
          id: item.id,
          name: item.name || "",
          last_name: item.last_name || "",
          count_coupons: 1,
        }));
      },
      immediate: true,
    },
    selected_users: {
      handler(val) {
        this.$emit("selected_users", val);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
